// "Faz entrega?" do cadastro de vendedores — guardado SEM backend.
//
// Alguns vendedores levam o material eles mesmos. Com "Sim", o app (ESF-APP-
// SUPLEN) mostra pra ele o card Entregas, o mesmo módulo do motorista. A API
// não tem coluna pra isso e a ideia foi não depender do backend, então a
// marcação vai dentro de `colaboradores.informacao_adicional` (texto livre,
// varchar 3000), o único campo do colaborador que:
// - o PUT /colaborador/:id já salva (como `informacaoAdicional`);
// - a sincronização com o ERP NÃO sobrescreve (ela regrava nome/região/
//   hierarquia, não esse campo);
// - o app consegue ler com o token do próprio vendedor (GET /colaborador/:id).
//
// A tela esconde a marca do input "Informação Adicional" e a recoloca ao
// salvar. O app procura a MESMA string (helpers/vendedor-entrega.ts lá) —
// mudar aqui exige mudar lá. Quando o backend ganhar um campo de verdade
// (ex.: colaboradores.faz_entrega), este arquivo é o que sai.
export const MARCA_FAZ_ENTREGA = '[ENTREGA:SIM]';

const TEM_MARCA = /\[ENTREGA:SIM\]/i;
const MARCA_COM_ESPACOS = /\s*\[ENTREGA:SIM\]\s*/gi;

export const vendedorFazEntrega = (informacaoAdicional?: string | null): boolean =>
  TEM_MARCA.test(informacaoAdicional ?? '');

// O que o input mostra: o texto que a pessoa escreveu, sem a marca.
export const textoSemMarcaEntrega = (informacaoAdicional?: string | null): string =>
  (informacaoAdicional ?? '').replace(MARCA_COM_ESPACOS, ' ').trim();

// O que vai pro PUT: o texto do input com a marca na frente quando "Sim".
export const informacaoComMarcaEntrega = (
  texto: string | null | undefined,
  fazEntrega: boolean
): string => {
  const limpo = textoSemMarcaEntrega(texto);
  if (!fazEntrega) return limpo;
  return limpo ? `${MARCA_FAZ_ENTREGA} ${limpo}` : MARCA_FAZ_ENTREGA;
};
